export const WEB_URL = window.endPoint.WEB_URL;
export const BASE_URL = window.endPoint.BASE_URL;
export const IMAGE_URL = window.endPoint.IMAGE_URL;
export const VENDOR_IMAGE_URL = window.endPoint.VENDOR_IMAGE_URL;
export const AUTO_SAVE_TIME = window.endPoint.AUTO_SAVE_TIME;
export const SESSION_EXPIRE_TIME = window.endPoint.SESSION_EXPIRE_TIME;
export const NOTIFICATION_API_CALL_TIME = window.endPoint.NOTIFICATION_API_CALL_TIME;
export const UNDO_REDO_STACK_LIMIT = window.endPoint.UNDO_REDO_STACK_LIMIT;
export const GA_ID = window.endPoint.GA_ID;
export const ENVIRONMENT = window.endPoint.ENVIRONMENT;
